// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_bmPSz {
  background: var(--white-color);
  /* border-radius: 8px; */
  padding: 8px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d9d9d9;
}

.row1_eaCtr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .left_cvAuu{
    display: flex;
  }
  .right_wWVvw{
    .firstLine_ZVqod{
      font-size: 10px;
      display: flex;
      align-items: center;
      gap: 3px;
      span{
        display: flex;
      align-items: center;
      gap: 3px;
      }
    }
    .secondLine_kZU5a{
      display: flex;
      justify-content: end;
      gap: 5px;
      button{
        display:flex;
        align-items: center;
        gap:5px;
        border-radius: 8px;
        color:#4F5660;
        border: none;
        padding: 5px;
        font-size:11px;
      }
    }
  }
}

.avatar_NtO1U {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 16px;
  background-color: var(--10b981-background);
}

.texts_u4fAk {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.title_dbqqg {
  font-size: 14px;
  color: var(--black-color);
  display: flex;
  align-items: center;
  gap: 5px;
}

.subtitles_pjPCi {
  display: flex;
  font-size: 12px;
  color: var(--_6-color);
  margin-top: 4px;
}

.subtitles_pjPCi span:first-child {
  flex: 1 1;
}

.rightSubtitle_bgpGV {
  margin-left: auto;
}

.description_pzCmB {
  color: var(--_6-color);
  font-size: 0.9rem;
  /* margin: 12px 0;
  margin-bottom: 24px; */
}

.row2_HRGA4 {
    position: relative;
  display: flex;
  justify-content: space-between;
  
  margin-top: auto;
  .left_cvAuu{
    display: flex;
    align-items: center;
    gap: 5px;
    .textContainer_mh1MW{
      display: flex;
      align-items: center;
      gap:5px;
      .colorGrey_IuzEC{
        color:#9F9595;
      }
    }
    span{
      font-size: 12px;
    }
  }
}


.inputInButton_xuRVK{
    border:none;
    background-color: var(--ececf1-background);;
    width: 65px;
}
.inputInButton_xuRVK::placeholder{
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ExploreCommuniti/CardExplore/CardExplore.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB;IACE,aAAa;EACf;EACA;IACE;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR;QACE,aAAa;MACf,mBAAmB;MACnB,QAAQ;MACR;IACF;IACA;MACE,aAAa;MACb,oBAAoB;MACpB,QAAQ;MACR;QACE,YAAY;QACZ,mBAAmB;QACnB,OAAO;QACP,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,cAAc;MAChB;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB;wBACsB;AACxB;;AAEA;IACI,kBAAkB;EACpB,aAAa;EACb,8BAA8B;;EAE9B,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,aAAa;MACb,mBAAmB;MACnB,OAAO;MACP;QACE,aAAa;MACf;IACF;IACA;MACE,eAAe;IACjB;EACF;AACF;;;AAGA;IACI,WAAW;IACX,0CAA0C;IAC1C,WAAW;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":[".card {\n  background: var(--white-color);\n  /* border-radius: 8px; */\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.row1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  .left{\n    display: flex;\n  }\n  .right{\n    .firstLine{\n      font-size: 10px;\n      display: flex;\n      align-items: center;\n      gap: 3px;\n      span{\n        display: flex;\n      align-items: center;\n      gap: 3px;\n      }\n    }\n    .secondLine{\n      display: flex;\n      justify-content: end;\n      gap: 5px;\n      button{\n        display:flex;\n        align-items: center;\n        gap:5px;\n        border-radius: 8px;\n        color:#4F5660;\n        border: none;\n        padding: 5px;\n        font-size:11px;\n      }\n    }\n  }\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  margin-right: 16px;\n  background-color: var(--10b981-background);\n}\n\n.texts {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-size: 14px;\n  color: var(--black-color);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.subtitles {\n  display: flex;\n  font-size: 12px;\n  color: var(--_6-color);\n  margin-top: 4px;\n}\n\n.subtitles span:first-child {\n  flex: 1;\n}\n\n.rightSubtitle {\n  margin-left: auto;\n}\n\n.description {\n  color: var(--_6-color);\n  font-size: 0.9rem;\n  /* margin: 12px 0;\n  margin-bottom: 24px; */\n}\n\n.row2 {\n    position: relative;\n  display: flex;\n  justify-content: space-between;\n  \n  margin-top: auto;\n  .left{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    .textContainer{\n      display: flex;\n      align-items: center;\n      gap:5px;\n      .colorGrey{\n        color:#9F9595;\n      }\n    }\n    span{\n      font-size: 12px;\n    }\n  }\n}\n\n\n.inputInButton{\n    border:none;\n    background-color: var(--ececf1-background);;\n    width: 65px;\n}\n.inputInButton::placeholder{\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_bmPSz`,
	"row1": `row1_eaCtr`,
	"left": `left_cvAuu`,
	"right": `right_wWVvw`,
	"firstLine": `firstLine_ZVqod`,
	"secondLine": `secondLine_kZU5a`,
	"avatar": `avatar_NtO1U`,
	"texts": `texts_u4fAk`,
	"title": `title_dbqqg`,
	"subtitles": `subtitles_pjPCi`,
	"rightSubtitle": `rightSubtitle_bgpGV`,
	"description": `description_pzCmB`,
	"row2": `row2_HRGA4`,
	"textContainer": `textContainer_mh1MW`,
	"colorGrey": `colorGrey_IuzEC`,
	"inputInButton": `inputInButton_xuRVK`
};
export default ___CSS_LOADER_EXPORT___;
